import { isAxiosError } from "axios"

import axiosInstance from "~/api/api.axiosInstance"

import type {
  UpdateProposalIncentiveStatusesDto,
  UpdateProposalIncentiveStatusesResponseDto,
} from "../dto/proposal-incentive.dto"

export class ProposalIncentiveService {
  public async updateStatuses(
    proposalId: string,
    data: UpdateProposalIncentiveStatusesDto,
  ): Promise<UpdateProposalIncentiveStatusesResponseDto> {
    try {
      const response =
        await axiosInstance.put<UpdateProposalIncentiveStatusesResponseDto>(
          `/v2/proposal-incentives/${proposalId}/statuses`,
          data,
        )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to update proposal incentives`)
    }
  }
}

function toServiceError(error: unknown, fallbackMessage: string): Error {
  if (isAxiosError(error)) {
    return new Error(error.response?.data?.message ?? fallbackMessage)
  }
  if (error instanceof Error) {
    return error
  }

  return new Error(fallbackMessage)
}

export const proposalIncentiveService = new ProposalIncentiveService()
